import React, { useState } from "react";
import "./index.scss";

import { useNavigate } from "react-router-dom";

import UserService from "../../../services/user-auth/user.service";
import { showErrorToaster } from "../../../components/toaster/error";
import { showSuccessToaster } from "../../../components/toaster/success";
const userService = new UserService();

const UserForm = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    image: null,
  });
  const [imagePreview, setImagePreview] = useState(null); // Pour l'aperçu de l'image
  const [error, setError] = useState("");
  const [data, setJobList] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0]; // Récupère le fichier sélectionné
    if (file) {
      setFormData((prevData) => ({
        ...prevData,
        image: file, // Met à jour l'image dans l'état
      }));
      setImagePreview(URL.createObjectURL(file)); // Met à jour l'aperçu de l'image
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setJobList([...data, formData]);

    if (!formData.name || !formData.email) {
      setError("Veuillez remplir tous les champs.");
      return;
    }

    try {
      const formDataToSend = new FormData();
      formDataToSend.append("name", formData.name);
      formDataToSend.append("email", formData.email);

      formDataToSend.append("image", formData.image);

      // Sinon, on crée une nouvelle réalisation
      await userService.createUsers(formDataToSend);

      showSuccessToaster("Création réussie.");

      navigate("/user-liste");
    } catch (error) {
      showErrorToaster(
        error.response
          ? error.response.data.message
          : "Une erreur est survenue, veuillez réessayer."
      );
    }
  };

  return (
    <div className="job-form-container">
      <h1> Créer un utilisateur </h1>
      <form onSubmit={handleSubmit}>
        {error && <div className="error-message">{error}</div>}
        <div className="form-group">
          <label>Nom et prénom :</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>email:</label>
          <input
            type="text"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label>Image:</label>
          <input
            type="file"
            name="image"
            accept="image/*"
            onChange={handleImageChange}
          />

          <p></p>
        </div>
        <button type="submit" className="submit-button">
          Créer
        </button>
      </form>
    </div>
  );
};

export default UserForm;
